import { render } from "./startAcceptanceDialog.vue?vue&type=template&id=de38776c"
import script from "./startAcceptanceDialog.vue?vue&type=script&lang=js"
export * from "./startAcceptanceDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__